export enum RiskConsequenceCategory {
    Financial = 1,
    LegalAndRegulatory = 2,
    ReputationAndTrust = 3,
    Operational = 4,
    DataSubjectsAndDataProtection = 5,
    SecurityAndPhysical = 6,
    Strategic = 7,
}

export interface RiskConsequenceViewModel {
    id: string;
    name: string;
    description?: string;
    category: RiskConsequenceCategory;
    appliesToAllRiskAreas: boolean;
    riskAreas: Array<{ id: string; name: string }>;
}

export interface RiskConsequencesViewModel {
    items: Array<RiskConsequenceViewModel>;
    hasCatalogItemsToImport: boolean;
}
